import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = {
  class: "text-color-um-blue mt-4",
  style: {"line-height":"1.2"}
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_4 = { style: {"max-width":"340px","margin":"20px auto"} }
const _hoisted_5 = { class: "p-float-label" }
const _hoisted_6 = { class: "p-float-label" }
const _hoisted_7 = { class: "p-float-label" }
const _hoisted_8 = { class: "p-float-label" }
const _hoisted_9 = { class: "p-float-label" }
const _hoisted_10 = { class: "p-float-label" }
const _hoisted_11 = { class: "text-color-gray -mb-1 -mt-1 pl-2" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("hr", { class: "mt-4 mb-5" }, null, -1)
const _hoisted_13 = { class: "p-float-label" }
const _hoisted_14 = { class: "p-float-label" }
const _hoisted_15 = { class: "p-float-label" }
const _hoisted_16 = { class: "text-color-gray -mb-1 -mt-1 pl-2" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("hr", { class: "my-5" }, null, -1)
const _hoisted_18 = { class: "field -mb-1" }
const _hoisted_19 = { class: "grid align-items-center justify-content-between" }
const _hoisted_20 = { class: "col py-0" }
const _hoisted_21 = { class: "col py-0 flex-none" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("hr", { class: "mt-4 mb-5" }, null, -1)
const _hoisted_23 = { class: "field" }
const _hoisted_24 = { class: "flex" }
const _hoisted_25 = { style: {"margin-left":"-30px","margin-top":"25px"} }
const _hoisted_26 = { class: "pl-1" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_28 = { class: "field text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_InputPassword = _resolveComponent("InputPassword")!
  const _component_IconTextBlock = _resolveComponent("IconTextBlock")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    visible: _ctx.show,
    closable: true,
    title: _ctx.t('content.register.content.title')
  }, {
    beforeHeader: _withCtx(() => [
      _createElementVNode("img", {
        src: _ctx.getLogoByLocale,
        alt: "RiUM",
        style: {"width":"230px"}
      }, null, 8, _hoisted_1),
      _createElementVNode("h3", _hoisted_2, [
        _createTextVNode(_toDisplayString(_ctx.t("content.register.header.title")) + " ", 1),
        _createElementVNode("a", {
          class: "router-link",
          style: {"cursor":"pointer"},
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onClickLogin()))
        }, _toDisplayString(_ctx.t("content.register.header.navigateTo")), 1),
        _hoisted_3,
        _createTextVNode(" " + _toDisplayString(_ctx.t("content.register.header.subTitle")), 1)
      ])
    ]),
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_InputText, {
            modelValue: _ctx.v$.user.firstName.$model,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.v$.user.firstName.$model) = $event)),
            type: "text",
            class: _normalizeClass(["w-full", {
              'p-invalid': _ctx.v$.user.firstName.$invalid && _ctx.state.submitted,
            }])
          }, null, 8, ["modelValue", "class"]),
          _createElementVNode("label", null, _toDisplayString(_ctx.t("content.register.content.firstnamePlaceholder")) + "*", 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_InputText, {
            modelValue: _ctx.v$.user.lastName.$model,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.v$.user.lastName.$model) = $event)),
            type: "text",
            class: _normalizeClass(["w-full", {
              'p-invalid': _ctx.v$.user.lastName.$invalid && _ctx.state.submitted,
            }])
          }, null, 8, ["modelValue", "class"]),
          _createElementVNode("label", null, _toDisplayString(_ctx.t("content.register.content.surnamePlaceholder")) + "*", 1)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_InputText, {
            modelValue: _ctx.v$.user.email.$model,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.v$.user.email.$model) = $event)),
            type: "email",
            class: _normalizeClass(["w-full", { 'p-invalid': _ctx.v$.user.email.$invalid && _ctx.state.submitted }])
          }, null, 8, ["modelValue", "class"]),
          _createElementVNode("label", null, _toDisplayString(_ctx.t("content.register.content.emailPlaceholder")) + "*", 1)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_InputText, {
            modelValue: _ctx.v$.user.phoneNumber.$model,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.v$.user.phoneNumber.$model) = $event)),
            type: "text",
            class: _normalizeClass(["w-full", {
              'p-invalid': _ctx.v$.user.phoneNumber.$invalid && _ctx.state.submitted,
            }])
          }, null, 8, ["modelValue", "class"]),
          _createElementVNode("label", null, _toDisplayString(_ctx.t("content.register.content.phonePlaceholder")) + "*", 1)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_Dropdown, {
            modelValue: _ctx.v$.user.researcherStatusId.$model,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.v$.user.researcherStatusId.$model) = $event)),
            options: _ctx.getResearchEquipmentCategories.researcherStatuses,
            "option-label": "name",
            "option-value": "id",
            class: _normalizeClass(["w-full", {
              'p-invalid':
                _ctx.v$.user.researcherStatusId.$invalid && _ctx.state.submitted,
            }])
          }, null, 8, ["modelValue", "options", "class"]),
          _createElementVNode("label", null, _toDisplayString(_ctx.t("content.register.content.researcherStatusPlaceholder")) + "*", 1)
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_Dropdown, {
            modelValue: _ctx.v$.user.researchInstitutionMSTID.$model,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.v$.user.researchInstitutionMSTID.$model) = $event)),
            editable: true,
            options: _ctx.state.researchInstitutions,
            "option-label": "name",
            "option-value": "mstid",
            filter: true,
            class: _normalizeClass(["w-full", {
              'p-invalid':
                _ctx.v$.user.researchInstitutionMSTID.$invalid && _ctx.state.submitted,
            }]),
            "show-clear": true,
            onFilter: _cache[7] || (_cache[7] = ($event: any) => (_ctx.onResearchInstitutionFilterChange($event))),
            onChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.onResearchInstitutionChange($event)))
          }, null, 8, ["modelValue", "options", "class"]),
          _createElementVNode("label", null, _toDisplayString(_ctx.t("content.register.content.researchInstitution")) + "*", 1)
        ]),
        _createElementVNode("p", _hoisted_11, " ( * " + _toDisplayString(_ctx.t("content.register.footer.mandatoryText")) + " ) ", 1),
        _hoisted_12,
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_component_InputText, {
            modelValue: _ctx.v$.user.username.$model,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.v$.user.username.$model) = $event)),
            type: "text",
            class: _normalizeClass(["w-full", {
              'p-invalid': _ctx.v$.user.username.$invalid && _ctx.state.submitted,
            }])
          }, null, 8, ["modelValue", "class"]),
          _createElementVNode("label", null, _toDisplayString(_ctx.t("content.register.content.usernamePlaceholder")) + "*", 1)
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_component_InputPassword, {
            modelValue: _ctx.v$.user.password.$model,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.v$.user.password.$model) = $event)),
            class: _normalizeClass(["w-full", {
              'p-invalid': _ctx.v$.user.password.$invalid && _ctx.state.submitted,
            }]),
            "toggle-mask": ""
          }, null, 8, ["modelValue", "class"]),
          _createElementVNode("label", null, _toDisplayString(_ctx.t("content.register.content.passwordPlaceholder")), 1)
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createVNode(_component_InputPassword, {
            modelValue: _ctx.v$.user.passwordRepeat.$model,
            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.v$.user.passwordRepeat.$model) = $event)),
            class: _normalizeClass(["w-full", {
              'p-invalid': _ctx.v$.user.passwordRepeat.$invalid && _ctx.state.submitted,
            }]),
            "toggle-mask": ""
          }, null, 8, ["modelValue", "class"]),
          _createElementVNode("label", null, _toDisplayString(_ctx.t("content.register.content.repeatPasswordPlaceholder")), 1)
        ]),
        _createElementVNode("p", _hoisted_16, " ( " + _toDisplayString(_ctx.t("content.register.content.passwordRecommendationInfo")) + " ) ", 1),
        _hoisted_17,
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.t("content.register.footer.needHelpText")) + "? ", 1),
            _createElementVNode("div", _hoisted_21, [
              _createVNode(_component_IconTextBlock, {
                icon: "icon-envelope-4",
                "icon-color": true,
                label: _ctx.location.email,
                href: `mailto:${_ctx.location.email}`,
                class: "iconTextBlock--icon-lg"
              }, null, 8, ["label", "href"])
            ])
          ])
        ]),
        _hoisted_22,
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              _createVNode(_component_Checkbox, {
                modelValue: _ctx.state.consentEnabled,
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.state.consentEnabled) = $event)),
                binary: true,
                class: _normalizeClass({
                  'p-invalid': _ctx.v$.consentEnabled.$invalid && _ctx.state.submitted,
                })
              }, null, 8, ["modelValue", "class"]),
              _createVNode(_component_Checkbox, {
                modelValue: _ctx.state.gdprConsentEnabled,
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.state.gdprConsentEnabled) = $event)),
                binary: true,
                class: _normalizeClass({
                  'p-invalid':
                    _ctx.v$.gdprConsentEnabled.$invalid && _ctx.state.submitted,
                })
              }, null, 8, ["modelValue", "class"])
            ]),
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("p", null, [
                _createTextVNode(_toDisplayString(_ctx.t("content.register.footer.termsOfUseText1")) + " ", 1),
                _hoisted_27,
                _createVNode(_component_router_link, {
                  class: "router-link text-color-blue",
                  to: "/terms-and-conditions",
                  target: "_blank"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("strong", null, _toDisplayString(_ctx.t("content.register.footer.termsOfUseText2")), 1)
                  ]),
                  _: 1
                }),
                _createTextVNode(" " + _toDisplayString(_ctx.t("content.register.footer.termsOfUseText3")) + " ", 1),
                _createVNode(_component_router_link, {
                  class: "router-link text-color-blue",
                  to: "/gdpr-rights-researcher",
                  target: "_blank"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("strong", null, _toDisplayString(_ctx.t("content.register.footer.termsOfUseTextResearcher")), 1)
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_28, [
          _createVNode(_component_Button, {
            label: _ctx.t('header.registerTitle'),
            class: "minWidth",
            onClick: _ctx.onClickRegister
          }, null, 8, ["label", "onClick"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["visible", "title"]))
}